import { JobsTable } from './components/jobs-table';

export const Jobs = () => {
  return <JobsTable />;
};
